var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.502,
    height: 28.637,
    viewBox: "0 0 40.502 28.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2962",
    "data-name": "Group 2962",
    transform: "translate(-20164 -8801.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4202",
    "data-name": "Path 4202",
    d: "M313.425,107.52a2.983,2.983,0,0,1,1.71.5l3.388,3.1a37.1,37.1,0,0,1,2.942,2.409l3.077,2.86,5.426-6.287-8.432-8.071-2.03,1.992a6.419,6.419,0,0,1-1.151-.383l-3.18-1.548a3.129,3.129,0,0,0-1.348-.278,3.431,3.431,0,0,0-1.921.544l-4.92,3.45a1.858,1.858,0,0,0-.42,2.629l.292.394a2.134,2.134,0,0,0,1.709.833,2.042,2.042,0,0,0,1.059-.288l2.334-1.49a2.878,2.878,0,0,1,1.467-.371Z",
    transform: "translate(19874.533 8699.667)",
    fill: "#00aa9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4203",
    "data-name": "Path 4203",
    d: "M132.13,125.369l-5.149-4.785c-.447-.364-1.445-1.127-1.445-1.127l-3.227-2.956a1.036,1.036,0,0,0-.348-.056.831.831,0,0,0-.295.045l-2.34,1.492a4.3,4.3,0,0,1-2.223.612,4.388,4.388,0,0,1-3.521-1.747l-.291-.392a4.114,4.114,0,0,1,.937-5.82l.53-.371a4.579,4.579,0,0,0-2.232.253s-1.04.457-1.372.6a5.59,5.59,0,0,1-1.856.323l-2.542-2.368L98,117.764l3.291,3.31.747-.784a4.166,4.166,0,0,1,5.883-.14l.354.338a4.15,4.15,0,0,1,1.008,1.5,4.129,4.129,0,0,1,1.827,1.016l.353.337a4.127,4.127,0,0,1,1.288,2.91,4.106,4.106,0,0,1,.685.53l.356.34a4.131,4.131,0,0,1,1.063,1.659,4.126,4.126,0,0,1,1.7.978l.36.342a4.171,4.171,0,0,1,.663,5.207l.27.252a1.91,1.91,0,0,0,2.692-.1l.333-.36a1.9,1.9,0,0,0-.06-2.64l2.469,2.29a1.912,1.912,0,0,0,2.693-.1l.333-.359a1.909,1.909,0,0,0-.088-2.679l.634.59a1.91,1.91,0,0,0,2.691-.1l.334-.359a1.913,1.913,0,0,0-.1-2.693l-.536-.5a1.908,1.908,0,0,0,2.648-.133l.335-.359a1.909,1.909,0,0,0-.1-2.693Z",
    transform: "translate(20065.998 8692.998)",
    fill: "#00aa9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4204",
    "data-name": "Path 4204",
    d: "M133.325,271.226l-.356-.339a1.909,1.909,0,0,0-2.692.064l-.006-.01a1.911,1.911,0,0,0-.065-2.692l-.356-.339a1.884,1.884,0,0,0-1.3-.521,1.915,1.915,0,0,0-1.317.523l.714-.748a1.909,1.909,0,0,0-.064-2.693l-.355-.339a1.909,1.909,0,0,0-2.657.032,1.9,1.9,0,0,0-.177-2.547l-.354-.338a1.911,1.911,0,0,0-2.694.064l-3.577,3.751a1.907,1.907,0,0,0,.066,2.692l.354.338a1.882,1.882,0,0,0,1.3.519A1.917,1.917,0,0,0,121,268.21l-.943.987a1.913,1.913,0,0,0,.064,2.693l.357.339a1.909,1.909,0,0,0,2.693-.064l.736-.772a1.906,1.906,0,0,0,.123,2.617l.357.339a1.909,1.909,0,0,0,2.692-.064l1.183-1.224a1.909,1.909,0,0,0,.064,2.693l.356.339a1.908,1.908,0,0,0,2.691-.064l2.015-2.112a1.911,1.911,0,0,0-.065-2.692Z",
    transform: "translate(20048.029 8553.505)",
    fill: "#00aa9f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/partners.951c40ca10c2db8b7d6134a7b8324b4a.svg";
export { ForwardRef as ReactComponent };